import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.background.paper,
        padding: '15px',
        rowGap: '15px',
        order: 2,
        bottom: 0,
        width: '100%',
        left: 0,
        position: 'fixed',
        zIndex: 1,
        [theme.breakpoints.up('lg')]: {
            order: 1,
            width: 'auto',
            position: 'unset',
            justifyContent: 'space-between',
        },
        ...(isHosTheme && {
            order: 'unset',
            position: 'unset',
            justifyContent: 'space-between',
            background: theme.palette.common.white,
            border: `0.5px solid ${theme.palette.secondary.dark}`,
            borderRadius: theme.custom.borderRadius[23],
            padding: '15px 20px',
        }),
    }),

    containerSantander: css({
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.background.paper,
        padding: '15px',
        rowGap: '15px',
        order: 2,
        bottom: 0,
        width: '100%',
        left: 0,
        position: 'fixed',
        zIndex: 1,
        [theme.breakpoints.up('lg')]: {
            order: 1,
            width: 'auto',
            position: 'unset',
            justifyContent: 'space-between',
        },
    }),

    optionText: css({
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'block',
        },
        ...(isHosTheme && {
            display: 'block',
            color: theme.palette.secondary.dark,
            fontSize: '14px',
            fontWeight: 400,
        }),
    }),

    iconsWrapper: css({
        display: 'flex',
        width: '186.721px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '25px',
        flexShrink: '0',
        height: '22px',
    }),

    iconsWrapperSantander: css({
        display: 'flex',
        width: '186.721px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '25px',
        flexShrink: '0',
        height: '22px',
        [theme.breakpoints.down('lg')]: {
            gap: '10px',
        },
    }),

    paymentIconsWithSideText: css({
        display: 'flex',
        gap: '25px',
        [theme.breakpoints.down('lg')]: {
            margin: isHosTheme ? 'inherit:' : '0 auto',
        },
    }),

    paymentIconsWithSideTextSantander: css({
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        [theme.breakpoints.down('lg')]: {
            margin: isHosTheme ? 'inherit:' : '0 auto',
        },
    }),

    icon1: css({
        width: '53.9px',
    }),

    icon2: css({
        width: '29px',
    }),

    icon3: css({
        width: '28.412px',
    }),
};
